module.exports = __webpack_public_path__ + "static/media/patternmm.bd4f7e1f.svg";